<template>
	<marketing-select class="w-32" v-bind="$attrs" mode="single" :canDeselect="false" :options="timeOptions" />
</template>

<script>
	import MarketingSelect from '@/components/marketing/forms/formComponents/MarketingSelect';
	import { mapGetters } from 'vuex';

	export default {
		name: 'MarketingTimePicker',
		components: { MarketingSelect },
		computed: {
			...mapGetters({
				timeOptions: 'timeOptions',
			}),
		},
	};
</script>
